import { missionData } from 'data/mission-data';


export function getMissionFromId(missionId) {
	const mission = missionData.find((mission) => {
		return mission.id === missionId;
	});

	return mission;
};